module.exports = __webpack_public_path__ + "static/media/BTCST-BNB.6264fd3f.svg";